import Toolbar from '@mui/material/Toolbar';
import { SocialIcon } from 'react-social-icons';
import { useTheme } from '@mui/material/styles';
import { Stack } from '@mui/material';
import { motion } from 'framer-motion';
import { getConfig } from '../config';
import { blue, yellow } from '@mui/material/colors';

const artist = getConfig().artist;

const socialMediaLinks = [
    {
        name: 'SoundCloud',
        url: `https://www.soundcloud.com/${artist.soundcloud}`,
    },
    {
        name: 'Instagram',
        url: `https://www.instagram.com/${artist.instagram}`,
        colorOverride: blue[900],
    },
    {
        name: 'Spotify',
        url: `https://open.spotify.com/artist/${artist.spotifyId}`,
        colorOverride: yellow[800],
    },
    {
        name: 'X',
        url: `https://x.com/${artist.x}`,
    },
    {
        name: 'Bandsintown',
        url: `https://www.bandsintown.com/a/${artist.bandsInTownId}`,
        colorOverride: blue[900],
    },
    {
        name: 'YouTube',
        url: `https://www.youtube.com/channel/${artist.youTubeId}`,
        colorOverride: yellow[800],
    },
];

const SocialBar = () => {
    const theme = useTheme();

    return (
        <Toolbar
            disableGutters
            sx={{
                justifyContent: 'center',
            }}
        >
            <motion.div
                initial='hidden'
                animate='visible'
                variants={{
                    hidden: {},
                    visible: { transition: { staggerChildren: 0.08, delayChildren: 0.2 } },
                }}
            >
                <Stack spacing={1} direction='row'>
                    {socialMediaLinks.map((link, index) => (
                        <motion.div
                            key={index}
                            variants={{
                                hidden: { opacity: 0, y: 12, scale: 0.8 },
                                visible: { opacity: 1, y: 0, scale: 1, transition: { duration: 0.35 } },
                            }}
                            whileHover={{ scale: 1.2, y: -3 }}
                            whileTap={{ scale: 0.9 }}
                            transition={{ type: 'spring', stiffness: 400, damping: 14 }}
                        >
                            <SocialIcon
                                url={link.url}
                                target='_blank'
                                fgColor={theme.palette.secondary.main}
                                bgColor={link.colorOverride ? link.colorOverride : theme.palette.primary.main}
                                aria-label={link.name}
                                style={{ height: 40, width: 40, display: 'block' }}
                            />
                        </motion.div>
                    ))}
                </Stack>
            </motion.div>
        </Toolbar>
    );
};

export default SocialBar;
